import { Button, Popconfirm, message } from 'antd'
import { BsFillTrashFill } from 'react-icons/bs'
import { CloseCircleFilled } from '@ant-design/icons'
import deleteProcess from 'services/processes/deleteProcess'

function DeleteProcess({ processId, successCallback }) {
  async function handleDelete() {
    try {
      await deleteProcess(processId)
      if (typeof successCallback === 'function') successCallback()
      message.success('Processo deletado com sucesso!')
    } catch (err) {
      console.error('Erro ao deletar processo', err)
      message.error('Erro ao excluir o processo. Tente novamente.')
    }
  }

  return (
    <Popconfirm
      placement='topRight'
      title='Excluir Processo'
      description='Deseja excluir este processo?'
      onConfirm={handleDelete}
      okText='Excluir'
      cancelText='Cancelar'
      icon={<CloseCircleFilled style={{ color: '#f5222d' }} />}
    >
      <Button   title='Excluir Processo'>
        <BsFillTrashFill />
      </Button>
    </Popconfirm>
  )
}

export default DeleteProcess
